<template>
    <div
        class="modal tw-fixed tw-w-full tw-h-full tw-top-0 tw-left-0 tw-flex tw-items-center tw-justify-center tw-z-50 tw-duration-300"
        :class="{'tw-opacity-0 tw-pointer-events-none' : !$store.getters.openModals }"
    >
        <div class="modal-overlay tw-absolute tw-w-full tw-h-full tw-bg-black tw-opacity-50"></div>
        <div class="modal-container tw-bg-white tw-my-6 tw-max-h-3/4 md:tw-max-w-screen-md tw-w-11/12 tw-mx-auto tw-rounded-lg tw-shadow-lg tw-z-50 tw-overflow-y-auto">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalContainer',
};
</script>

<style>

</style>
